import { createI18n } from 'vue-i18n'
import en from '@/i18n/en.json'
import es from '@/i18n/es.json'
import ca from '@/i18n/ca.json'

export default createI18n({
  locale: import.meta.env.VITE_DEFAULT_LOCALE,
  fallbackLocale: import.meta.env.VITE_FALLBACK_LOCALE,
  legacy: false,
  messages: { en, es, ca },
})
